import { Clock, PieChart, CheckCircle, Check, Landmark, Repeat, CreditCard, FileText, Banknote, Euro } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const PAYMENT_METHODS = {
  virement: { label: 'Virement', icon: Landmark, color: 'bg-blue-500' },
  sepa: { label: 'SEPA', icon: Repeat, color: 'bg-indigo-500' },
  cb: { label: 'Carte bancaire', icon: CreditCard, color: 'bg-emerald-500' },
  cheque: { label: 'Chèque', icon: FileText, color: 'bg-amber-500' },
  especes: { label: 'Espèces', icon: Banknote, color: 'bg-green-500' },
  stripe: { label: 'Stripe', icon: CreditCard, color: 'bg-violet-500' },
};

export const getPaymentMethod = (mode) => {
  if (!mode) return { label: 'N/A', icon: Euro, color: 'bg-gray-500' };
  return PAYMENT_METHODS[mode.toLowerCase()] || { label: mode, icon: Euro, color: 'bg-gray-500' };
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch { return dateStr; }
};

export const formatMoney = (amount) => {
  if (amount === null || amount === undefined) return '0,00';
  return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
};

export const CONTRIBUTION_STATUS = {
  pending: { label: 'En attente', color: 'bg-amber-100 text-amber-700', icon: Clock },
  partial: { label: 'Partiellement payé', color: 'bg-blue-100 text-blue-700', icon: PieChart },
  paid: { label: 'Payé', color: 'bg-emerald-100 text-emerald-700', icon: CheckCircle },
  acquitted: { label: 'Acquitté', color: 'bg-green-600 text-white', icon: Check },
};
